import { Drawer } from "@made-people/blueprint-drawer";
import { Cross } from "../../../../assets/icons/Cross";
import { useState, useEffect } from "react";
import { createEventEmitter } from "@made-people/grease-event-emitter";
import { overlayEventEmitter } from "@made-people/blueprint-overlay";
import { useTranslate } from "@made-people/grease-translations";
import { TrustpilotDrawerContent } from "./trustpilot-drawer-content";
import { useMaybeProductBase } from "@made-people/grease-product";
import type { TrustpilotDisplayData } from "@made-people/grease-trustpilot";

type ReviewsEvent = {
  openWithType: {
    type: "product" | "store";
    productSku?: string;
    productReviewsData?: TrustpilotDisplayData | null;
  };
};

export const reviewsEventEmitter = createEventEmitter<ReviewsEvent>();

export const openReviewsModal = (
  type: "product" | "store",
  productSku?: string,
  productReviewsData?: TrustpilotDisplayData | null,
) => {
  reviewsEventEmitter.emit("openWithType", {
    type,
    productSku,
    productReviewsData,
  });
  overlayEventEmitter.emit("open", { overlayId: "trustpilot-reviews" });
};

export const TrustpilotDrawer = () => {
  const translate = useTranslate();
  const product = useMaybeProductBase();
  const [type, setType] = useState<"product" | "store">("store");
  const [productSku, setProductSku] = useState<string | undefined>(undefined);
  const [productReviewsData, setProductReviewsData] =
    useState<TrustpilotDisplayData | null>(null);

  useEffect(() => {
    const handleOpenWithType = (event: ReviewsEvent["openWithType"]) => {
      setType(event.type);
      setProductSku(event.productSku);
      setProductReviewsData(event.productReviewsData ?? null);
    };

    reviewsEventEmitter.on("openWithType", handleOpenWithType);

    return () => {
      reviewsEventEmitter.off("openWithType", handleOpenWithType);
    };
  }, []);

  return (
    <Drawer
      customOverlayId="trustpilot-reviews"
      direction="right"
      hasHandle={false}
      hasOverlay={true}
      hasScaledBackground={true}
      setBackgroundColorOnScale={false}
      variants={{
        rounded: "strong",
        background: "none",
        direction: "right",
      }}
      header={{
        headingSettings: {
          heading: translate("Trustpilot_Reviews"),
        },
        closeIcon: <Cross className="w-4 h-4 absolute right-6 top-6" />,
      }}
    >
      <Drawer.Content
        contentSettings={{
          className: "w-[95%] md:max-w-[50%] lg:max-w-[30%]",
        }}
      >
        <div className="h-full overflow-y-auto overflow-x-hidden pb-10">
          <TrustpilotDrawerContent
            type={type}
            productSku={productSku ?? product?.productKey}
            productReviewsData={productReviewsData}
          />
        </div>
      </Drawer.Content>
    </Drawer>
  );
};
